import {hoistCmp} from '@xh/hoist/core';
import {StoreRecord} from '@xh/hoist/data';
import {div, filler, hbox, span, vbox} from '@xh/hoist/cmp/layout';
import {fmtNumber, fmtPercent} from '@xh/hoist/format';
import {Icon} from '@xh/hoist/icon';
import {button} from '@xh/hoist/desktop/cmp/button';
import classNames from 'classnames';
import {WatchListUpdate} from '../../../../data/DataTypes';
import {WatchlistPanelModel} from './WatchlistPanelModel';
import {fileChartPieIcon} from '../../../../../core/Icons';
import './WatchlistItem.scss';

/** One two-line quote row - ticker badge on the left, price over change on the right. */
export const itemRenderer = hoistCmp.factory<WatchlistPanelModel>({
    render({model, record}) {
        const item = (record as StoreRecord).data as WatchListUpdate & {prevPrice: number},
            dir = item.priceChange > 0 ? 'up' : item.priceChange < 0 ? 'down' : 'flat',
            tick = item.price > item.prevPrice ? 'flash-green' : item.price < item.prevPrice ? 'flash-red' : null;

        return hbox({
            className: classNames('watchlist-item', `watchlist-item--${dir}`),
            onDoubleClick: () => model.sendToChart(item.ticker),
            items: [
                span({
                    className: 'watchlist-item__badge',
                    item: item.ticker,
                    title: item.securityName ?? item.ticker
                }),
                // Beside the badge, so the shortcuts line up with the ticker they act on
                div({
                    className: 'watchlist-item__actions',
                    items: [
                        button({
                            className: 'watchlist-item__button',
                            icon: Icon.chartLine(),
                            minimal: true,
                            tooltip: 'Send to Charts',
                            onClick: () => model.sendToChart(item.ticker)
                        }),
                        button({
                            className: 'watchlist-item__button',
                            icon: fileChartPieIcon(),
                            minimal: true,
                            tooltip: 'Send to Research',
                            onClick: () => model.sendToResearch(item.ticker)
                        })
                    ]
                }),
                vbox({
                    flex: 1,
                    className: 'watchlist-item__quote',
                    items: [
                        hbox(
                            filler(),
                            // Keyed on price so the flash animation restarts on every tick.
                            span({
                                key: item.price,
                                className: classNames('watchlist-item__price', tick),
                                item: fmtNumber(item.price, {precision: 2, prefix: '$'})
                            })
                        ),
                        hbox({
                            className: 'watchlist-item__change-row',
                            items: [
                                filler(),
                                span({
                                    className: 'watchlist-item__change',
                                    item: `${dir === 'up' ? '▲' : dir === 'down' ? '▼' : ''}${fmtNumber(Math.abs(item.priceChange ?? 0), {precision: 2})}`
                                }),
                                span({
                                    className: 'watchlist-item__pill',
                                    item: fmtPercent(item.priceChangePct, {precision: 2, withPlusSign: true})
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
});
